import { createAction, props } from '@ngrx/store';
import { SuiSortState as Sort } from '@semeris/ui';

import { DocumentDefinedTermViewModel, TermScope } from '../../features/deal/models/document-defined-term';
import { TermSynonymGroupCounts } from '../../features/deal/models/term-explorer.model';
import { TransactionId } from '../../features/market-comparison/models/column.model';

export namespace TermExplorerActions {
  export const LoadFinalDocumentTerms = createAction('[TermExplorer] Load Final Document Terms', props<{ documentId: string }>());
  export const LoadFinalDocumentTermsSuccess = createAction(
    '[TermExplorer] Load Final Document Terms Success',
    props<{ list: DocumentDefinedTermViewModel[] }>(),
  );
  export const LoadFinalDocumentTermsFail = createAction(
    '[TermExplorer] Load Final Document Terms Fail',
    props<{ error: string | object }>(),
  );

  export const CleanFinalDocumentTerms = createAction('[TermExplorer] Clean Final Document Terms');

  export const LoadOriginalDocumentTerms = createAction('[TermExplorer] Load Original Document Terms', props<{ documentId: string }>());
  export const LoadOriginalDocumentTermsSuccess = createAction(
    '[TermExplorer] Load Original Document Terms Success',
    props<{ list: DocumentDefinedTermViewModel[] }>(),
  );
  export const LoadOriginalDocumentTermsFail = createAction(
    '[TermExplorer] Load Original Document Terms Fail',
    props<{ error: string | object }>(),
  );

  export const CleanOriginalDocumentTerms = createAction('[TermExplorer] Clean Original Document Terms');

  export const LoadDefinedTermOccurences = createAction(
    '[TermExplorer] Load Defined Term Occurences',
    props<{ transactionIds: TransactionId[] }>(),
  );
  export const LoadDefinedTermOccurenceChunk = createAction(
    '[TermExplorer] Load Defined Term Occurence Chunk',
    props<{ transactionIds: TransactionId[] }>(),
  );
  export const LoadDefinedTermOccurenceChunkSuccess = createAction(
    '[TermExplorer] Load Defined Term Occurence Chunk Success',
    props<{
      transactionIds: TransactionId[];
      occurences: Record<string, number>;
      synonymGroups: Record<string, TermSynonymGroupCounts>;
    }>(),
  );
  export const LoadDefinedTermOccurenceFail = createAction(
    '[TermExplorer] Load Defined Term Occurence Fail',
    props<{ error: string | object }>(),
  );

  export const Recalculate = createAction('[TermExplorer] Recalculate', props<{ withoutLimit?: boolean }>());

  export const SetTermScope = createAction('[TermExplorer] Set term scope', props<{ termScope: TermScope }>());
  export const SetSort = createAction('[TermExplorer] Set sort', props<{ sort: Sort }>());
  export const SetFocusMode = createAction('[TermExplorer] Set focus mode', props<{ focusMode: boolean }>());
  export const SetGroupSynonyms = createAction('[TermExplorer] Set group synonyms', props<{ groupSynonyms: boolean }>());
  export const SetSearch = createAction('[TermExplorer] Set search', props<{ searchTerm: string }>());
}
